import { ReactNode } from "react";
import cx from "classnames";

type SubSidebarProps = {
  children: ReactNode;
  className?: string;
};

import useSkipFocusButtons from "ds/components/SkipFocusButton/useSkipFocusButtons";
import useScrollOverflowDetection from "hooks/useScrollOverflowDetection";

import styles from "./styles.module.css";

const SubSidebar = ({ children, className }: SubSidebarProps) => {
  const [skipButton, backButton] = useSkipFocusButtons();
  const { scrollContainerRef, canScrollUp, canScrollDown } = useScrollOverflowDetection();

  return (
    <div className={cx(styles.wrapper, className)}>
      {skipButton({ label: "Skip sub-sidebar" })}
      <div
        className={cx(styles.scrollWrapper, {
          [styles.canScrollUp]: canScrollUp,
          [styles.canScrollDown]: canScrollDown,
        })}
      >
        <div ref={scrollContainerRef} className={styles.scrollContent}>
          {children}
        </div>
      </div>
      {backButton({ label: "Back to sub-sidebar", className: styles.backToNavigationButton })}
    </div>
  );
};

export default SubSidebar;
